import { Component } from 'react';

import type { Conversation } from '../../../../types';
import BEM from 'common/bem';
import { ReactComponent as PinIcon } from 'common/images/pin.svg';
import { mobxInjectSelect } from 'common/utils';

const classes = BEM.with('ConversationPinIcon');

type ConversationPinIconProps = {
  conversation: Conversation & {
    isPinned?: boolean;
    network?: 'PROVIDER' | 'PATIENT';
  };
  isParentHovered: boolean;
};

type MobxProps = {
  togglePinConversation: (conversation: Conversation) => void;
  logPinConversation: (conversation: Conversation) => void;
};

type CombinedProps = ConversationPinIconProps & MobxProps;

type State = {
  isHovered: boolean;
};

class ConversationPinIcon extends Component<CombinedProps, State> {
  state: State = {
    isHovered: false,
  };

  _onMouseEnter = (): void => {
    this.setState({ isHovered: true });
  };

  _onMouseLeave = (): void => {
    this.setState({ isHovered: false });
  };

  _onClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
    const { conversation, togglePinConversation, logPinConversation } = this.props;
    logPinConversation(conversation);
    togglePinConversation(conversation);
  };

  render() {
    const { conversation, isParentHovered } = this.props;
    const { isHovered } = this.state;
    const { isPinned } = conversation;

    // Show if pinned OR if parent is hovered OR if this icon is hovered
    const shouldShow = isPinned || isParentHovered || isHovered;
    const classConfig = { isPinned, hidden: !shouldShow };
    const generatedClassName = classes(classConfig);

    return (
      <div
        data-test-id="conversation-pin-icon"
        className={generatedClassName}
        onClick={this._onClick}
        onMouseEnter={this._onMouseEnter}
        onMouseLeave={this._onMouseLeave}
        aria-label={isPinned ? 'Unpin conversation' : 'Pin conversation'}
        role="button"
        style={{ opacity: shouldShow ? 1 : 0 }}
      >
        <PinIcon />
      </div>
    );
  }
}

export default mobxInjectSelect<ConversationPinIconProps, MobxProps>({
  conversationStore: ['togglePinConversation'],
  trackerStore: ['logPinConversation'],
})(ConversationPinIcon);
